import { render } from "./TonVerification.vue?vue&type=template&id=4dac9f7c&scoped=true"
import script from "./TonVerification.vue?vue&type=script&lang=js"
export * from "./TonVerification.vue?vue&type=script&lang=js"

import "./TonVerification.vue?vue&type=style&index=0&id=4dac9f7c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dac9f7c"]])

export default __exports__